<template>
  <b-card title="Create Awesome pages 🙌">
    <b-card-text>This is your page.</b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>

<style>

</style>
